import { useMemo } from 'react'
import { useSceneLineMarker } from '@editorHooks'

export interface VerticalOpeningHelper {
  lowerPoint: Point
  higherPoint: Point
}

interface AlignmentHelperProps {
  verticalOpeningHelpers: VerticalOpeningHelper[]
}

const AlignmentHelper = ({ verticalOpeningHelpers }: AlignmentHelperProps): null => {
  const lines = useMemo(() => {
    return verticalOpeningHelpers.map(helper => [helper.lowerPoint, helper.higherPoint])
  }, [verticalOpeningHelpers])

  useSceneLineMarker({
    lines,
    enabled: lines.length > 0,
    color: 'black',
    lineWidth: 6,
    renderOrder: 1000,
    disableDepthTest: false,
  })

  return null
}

export default AlignmentHelper
